<template>
  <div>
  <div class="sa-lab-test" v-for="(lablist,index) in selectTests" :key="index">
    <div class="sa-d-f-sbetween sa-cursor" @click="toggleList(index)">
      <span>
        <h6>{{lablist.test_name}}</h6>
        <span class="sa-gray-text">{{ lablist.test_count }} Test Incl</span>
      </span>
      <div>
        <span class="sa-d-i-block" v-if="$route.path == '/lab-appointments'">Tube: <small class="sa-tube sa-tube-red"></small><small class="sa-tube"></small><small class="sa-tube sa-tube-blue"></small></span>
        <span>
          <i
            :class="activeIndex===index ? 'icon-down-arrow ' : 'icon-up-arrow '"
            class="sa-gray-text"
          ></i>
        </span>
      </div>
    </div>
    <div class="sa-primary-lite-bg" v-if="activeIndex===index">
        <h6 class="sa-bold">{{lablist.tested_key}}</h6>
        <ul>
            <li v-for="(value,l) in lablist.tested_samples" :key="l">{{value}}</li>
        </ul>
    </div>
  </div>
</div>
</template>
<script>
export default {
  props:['selectTests'],
  data() {
    return {
        open:false,
        activeIndex:null
    };
  },
  methods: {
    toggleList(index){
      if(this.activeIndex === index){
        this.activeIndex=null
      }
      else{
        this.activeIndex=index
      }
    }
  },
};
</script>
